module.exports = __webpack_public_path__ + "images/fail.png";


//////////////////
// WEBPACK FOOTER
// ./components/Card/images/fail.png
// module id = 251
// module chunks = 2